export const GET_MANAGERS_STARTED = "GET_MANAGERS_STARTED"
export const GET_MANAGERS_SUCCESS = "GET_MANAGERS_SUCCESS"
export const GET_MANAGERS_FAILED = "GET_MANAGERS_FAILED"